import axios, { AxiosResponse } from 'axios';
import { $, $$ } from '@zimpa/dom';

type Response = {
    success?: boolean;
    message?: string;
};

class DigestManager {
    private visibleClass: string;
    private hideClass: string;
    private showClass: string;

    constructor(selectors: {
        root: string;
        form: string;
        error: string;
        result: string;
        trigger: string;
        container: string;
        visibleClass?: string;
        hideClass?: string;
        showClass?: string;
    }) {
        this.visibleClass = selectors.visibleClass || 'visible';
        this.hideClass = selectors.hideClass || 'hide';
        this.showClass = selectors.showClass || 'show';

        $$(selectors.root).forEach((root) => {
            const rootEl = root as HTMLElement;

            const formEl = rootEl.querySelector<HTMLFormElement>(selectors.form);
            const errorEl = rootEl.querySelector<HTMLElement>(selectors.error);
            const resultEl = rootEl.querySelector<HTMLElement>(selectors.result);
            const triggerEl = rootEl.querySelector<HTMLElement>(selectors.trigger);
            const containerEl = rootEl.querySelector<HTMLElement>(selectors.container);

            if (formEl && errorEl && resultEl && containerEl) {
                this.initFormSubmission(formEl, errorEl, resultEl);
                this.initAutoScroll(rootEl, containerEl);
                if(triggerEl) {
                    this.initTriggerBehavior(triggerEl, containerEl, rootEl);
                }
            }
        });

    }

    private initFormSubmission(
        formEl: HTMLFormElement,
        errorEl: HTMLElement,
        resultEl: HTMLElement
    ): void {
        formEl.addEventListener('submit', (event: Event): void => {
            event.preventDefault();
            const url = formEl.getAttribute('action');
            if (!url) return;

            const formData = new FormData(formEl);
            axios.post(url, formData).then((response: AxiosResponse<Response>): void => {
                formEl.classList.add(this.hideClass);

                if (response.data.success) {
                    resultEl.classList.add(this.showClass);
                } else {
                    errorEl.classList.add(this.showClass);
                }
            });
        });
    }

    private initTriggerBehavior(
        triggerEl: HTMLElement,
        containerEl: HTMLElement,
        root: HTMLElement
    ): void {
        triggerEl.addEventListener('click', (): void => {
            containerEl.classList.add(this.visibleClass);
            root.classList.add(this.visibleClass);
        });
    }

    private initAutoScroll(root: HTMLElement, containerEl: HTMLElement): void {
        window.addEventListener('load', () => {
            const hash = window.location.hash.toLowerCase();
            if (hash === '#houdmeopdehoogte' || hash === '#keepmeupdated') {
                window.scrollTo({
                    top: (root.offsetTop || 0) - 100,
                    behavior: 'smooth',
                });
                containerEl.classList.add(this.visibleClass);
            }
        });
    }
}

export function initializeDigest(): void {
    new DigestManager({
        root: '.js-digest-root',
        form: '.js-digest-form',
        error: '.js-digest-error',
        result: '.js-digest-result',
        trigger: '.js-digest-trigger',
        container: '.js-digest-container',
    });
}
